<div class="row">
  <div class="col col-12">
    <app-header />
  </div>
</div>

<div class="row">
  <div class="col col-12">
    @if (authService.user?.id == user0()!.id) {
      <form
        tuiAppearance="floating"
        tuiCardLarge
        [formGroup]="formProfil"
        (ngSubmit)="onSubmitProfil()"
      >
        <h2 class="tui-space_bottom-3">Mon profil</h2>
        <tui-textfield class="tui-space_bottom-5">
          <label tuiLabel>Login</label>
          <input
            formControlName="login"
            placeholder="login"
            [disabled]="true"
            tuiTextfield
          />
        </tui-textfield>
        <div class="tui-space_bottom-5">
          <div>
            <label tuiSubtitle>Signature</label>
            <signature-pad
              [options]="signaturePadOptions"
              (onEndEvent)="drawComplete()"
              formControlName="signature"
            ></signature-pad>
            <button
              appearance="outline"
              iconEnd="@tui.trash-2"
              size="s"
              tuiButton
              type="button"
              (click)="clearDraw()"
            ></button>
          </div>
        </div>
        <div class="tui-form__buttons">
          <button tuiButton class="tui-form__button" size="l" type="submit">
            Enregistrer
          </button>
        </div>
      </form>
    }
    <form
      tuiAppearance="floating"
      tuiCardLarge
      [formGroup]="formMotDePasse"
      (ngSubmit)="onSubmitMotDePasse()"
    >
      <h2 class="tui-space_bottom-3">Mot de passe</h2>

      @if (user0()) {
        @if (authService.user?.id == user0()!.id) {
          <tui-textfield class="tui-space_bottom-5">
            <label tuiLabel
              >Mot de passe actuel <span class="tui-required"></span
            ></label>
            <input
              formControlName="password"
              placeholder="mot de passe"
              type="password"
              tuiTextfield
            />
            <tui-error
              formControlName="password"
              [error]="[] | tuiFieldError | async"
            />
          </tui-textfield>
        }

        <tui-textfield class="tui-space_bottom-5">
          <label tuiLabel
            >Nouveau mot de passe <span class="tui-required"></span
          ></label>
          <input
            formControlName="new_password"
            placeholder="nouveau mot de passe"
            type="password"
            tuiTextfield
          />
          <tui-error
            formControlName="new_password"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>

        <tui-textfield class="tui-space_bottom-5">
          <label tuiLabel
            >Confirmation nouveau mot de passe <span class="tui-required"></span
          ></label>
          <input
            formControlName="confirm_password"
            placeholder="confirmation mot de passe"
            type="password"
            tuiTextfield
          />
          <tui-error
            formControlName="confirm_password"
            [error]="[] | tuiFieldError | async"
          />
          <!-- Display error message if the passwords do not match -->
          <div
            *ngIf="
              formMotDePasse.hasError('passwordsMismatch') &&
              formMotDePasse.get('confirm_password')?.touched
            "
            class="error-message"
          >
            Les mots de passe ne correspondent pas.
          </div>
        </tui-textfield>

        <div *ngIf="errorMessage" class="error-message tui-space_bottom-3">
          <tui-notification appearance="negative">{{
            errorMessage
          }}</tui-notification>
        </div>

        <div class="tui-form__buttons">
          <button
            tuiButton
            class="tui-form__button"
            size="l"
            type="submit"
            [disabled]="formMotDePasse.invalid"
          >
            Changer de mot de passe
          </button>
        </div>
      } @else {
        <tui-textfield class="tui-space_bottom-5">
          <label tuiLabel
            >Nouveau mot de passe <span class="tui-required"></span
          ></label>
          <input
            placeholder="nouveau mot de passe"
            type="password"
            [disabled]="true"
            tuiTextfield
          />
        </tui-textfield>

        <tui-textfield class="tui-space_bottom-5">
          <label tuiLabel
            >Confirmation nouveau mot de passe <span class="tui-required"></span
          ></label>
          <input
            placeholder="confirmation mot de passe"
            type="password"
            [disabled]="true"
            tuiTextfield
          />
        </tui-textfield>

        <div class="tui-form__buttons">
          <button
            tuiButton
            class="tui-form__button"
            size="l"
            type="submit"
            [disabled]="true"
          >
            Changer de mot de passe
          </button>
        </div>
      }
    </form>
  </div>
</div>
